import { Component, OnInit } from '@angular/core';
import { FeaturesService } from '../features.service';
import { MetaService } from '../meta.service';

@Component({
  selector: 'app-features',
  templateUrl: './features.component.html',
  styleUrls: ['./features.component.css']
})
export class FeaturesComponent implements OnInit {

  //declare variables
  features: any[] = [];

  constructor(private fs: FeaturesService, private mds: MetaService) { }

  ngOnInit(): void {
    //list of modules
    this.features = this.fs.getFeatures();

    //SEO Optimization
    var strTitle = 'RegScale - Features';
    var description = 'RegScalefeatures for both Community and Enterprise Editions';
    var keywords = 'RegScale, features, Community Edition (CE), Enterprise Edition (EE), APIs, Workflow, Audit Scheduling, Evidence Collection, Custom Fields, Multi-Tenancy';
    this.mds.updateTags(strTitle, keywords, description);
  }

}
